import { getUserScans } from '@/api';
import { ScanStatus } from '@/constants';

export const getFilteredScans = async (userId: string) => {
  const scansData = await getUserScans(userId);

  return scansData.filter(({ status }) => status !== ScanStatus.Canceled);
};
